<template>
  <v-dialog v-model="showQrCodeDialog" persistent max-width="600px">
    <v-card>
      <v-app-bar flat color="rgba(0, 0, 0, 0)">
        <v-toolbar-title class="text-h6 pl-0">
          <span class="headline">
            <v-icon class="mr-2">fal fa-qrcode</v-icon>Call Guide and Salesbook
          </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="showQrCodeDialog = false">
          <v-icon>fal fa-times fa-2x</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text>
        <v-container class="text-center">
          <v-img src="https://i.imgur.com/xkguF5z.png"></v-img>
          <v-btn
            depressed
            color="primary"
            href="https://drive.google.com/drive/folders/1EZPwHIxzMOUwjMKa2fGPTnY1QaeDrpw_?usp=sharing"
            target="_blank"
          >
            Go to Folder
          </v-btn>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'QrCodeDialog',
  props: {
    value: Boolean,
  },

  computed: {
    showQrCodeDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
